import { Dynamic } from 'components/dynamic';
import React from 'react';
import { connect } from 'react-redux';
import { resetState, setPrimaryPanelComponents } from 'redux/actions/global';

interface PanelsProps {
  primaryPanelView: any,
  secondaryPanelView: any,
  panelDisplayStates: any,
}
const Panels = (props: PanelsProps) => {
  const scrollToRef = (ref) => {
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const primaryPanelRef = React.createRef();
  const secondaryPanelRef = React.createRef();

  return (
    <div className="content">
      <Dynamic
        className="left"
        viewToShow={props.primaryPanelView}
        displayMode={props.panelDisplayStates.panelOneDisplay}
        ref={primaryPanelRef}
        scrollTo={() => scrollToRef(primaryPanelRef)}
      />
      <Dynamic
        className="right"
        viewToShow={props.secondaryPanelView}
        displayMode={props.panelDisplayStates.panelTwoDisplay}
        ref={secondaryPanelRef}
        scrollTo={() => scrollToRef(secondaryPanelRef)}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    primaryPanelView: state.global.primaryPanelView,
    secondaryPanelView: state.global.secondaryPanelView,
    panelDisplayStates: state.global.panelDisplayStates,
  };
}

const mapDispatchToProps = {
  resetState,
  setPrimaryPanelComponents,
};

export default connect(mapStateToProps, mapDispatchToProps)(Panels);
